<form class="w-100 h-100" [formGroup]="benefitForm" (ngSubmit)="isValid()">
  <mat-tab-group>
    <mat-tab label="Información de vista carrusel">
      <h4 class="text-center">{{benefitData.id ? 'Editar ' : 'Ingresar '}} información de cupón en carrusel</h4>
      <div class="row mx-0 my-3 p-0 w-100">
        <div class="col-12 pl-xl-0 mt-2 mb-4">
          <div class="vs-outline-editCard btn-custom-banner">
            <img class="given-img" [src]="fileImg64" alt="img-benefit-carrousel" *ngIf="fileImg64">
            <div class="btn-custom-file w-100">
              <label for="file-upload-logo" class="custom-file-upload h-fit-content p-3">
                <mat-icon>{{!fileImg64 ? 'image': '' }} </mat-icon>
                <span class="my-2" *ngIf="!wrongSize['c']">
                  {{benefitData['benefitsInstitutionId'] || fileImg64 ? 'Cambiar ' : 'Agregar'}}
                  imagen carrusel de 212px x 160px
                </span>
                <span class="my-2 text-danger" *ngIf="wrongSize['c']">{{wrongSize['c']}}</span>
              </label>
              <input id="file-upload-logo" type="file" accept="image/*" (change)="getBase64($event, 'carrousel')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-6 pl-xl-0">
          <mat-form-field class="example-full-width w-100" appearance="outline">
            <mat-label>Monto de descuento</mat-label>
            <input formControlName="discountMount" matInput placeholder="Ingresar monto..." type="text" maxlength="35">
            <mat-hint align="end">Ejemplo: 20%</mat-hint>
            <mat-hint> {{benefitForm.value.discountMount ? benefitForm.value.discountMount.length : 0}} de 35 caracteres máximos!</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12 col-xl-6 pr-xl-0">
          <mat-form-field class="example-full-width w-100" appearance="outline">
            <mat-label>Descripción de descuento</mat-label>
            <input formControlName="discountText" matInput placeholder="Ingresar descripción" type="text">
            <mat-hint align="end">Ejemplo: En todos los exámenes...</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12 col-xl-6 pl-xl-0">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Ubigeo</mat-label>
            <mat-select formControlName="ubigeoId">
              <mat-option *ngFor="let location of ubigeoList" [value]="location.id">
                {{location.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-xl-6 pr-xl-0">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Instituciones</mat-label>
            <mat-select formControlName="benefitsInstitutionId">
              <mat-option *ngFor="let institution of institutionsList" [value]="institution.id">
                {{institution.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Información de vista modal Paso 1">
      <div class="benefit-form-content py-2">
        <div class="vs-outline-editCard">
          <img class="given-img" [src]="fileImg64Detail" alt="img-benefit-slide" *ngIf="fileImg64Detail">
          <div class="btn-custom-file h-100 w-100">
            <label for="file-upload" class="custom-file-upload large text-center">
              <mat-icon>{{!fileImg64Detail ? 'image': '' }} </mat-icon>
              <span class="my-2" *ngIf="!wrongSize['s']">
                {{benefitData['benefitsInstitutionId'] || fileImg64Detail ? 'Cambiar ' : 'Agregar'}} imagen vertical de
                330px x 637px
              </span>
              <span class="my-2 text-danger" *ngIf="wrongSize['s']">{{wrongSize['s']}}</span>
            </label>
            <input id="file-upload" type="file" accept="image/*" (change)="getBase64($event, 'slider')" />
          </div>
        </div>
        <div class="h-100 px-2">
          <div class="vs-outline-editCard btn-custom-banner">
            <img class="given-img" [src]="fileImg64DetailMobile" alt="img-benefit-slideMobile"
              *ngIf="fileImg64DetailMobile">
            <div class="btn-custom-file w-100">
              <label for="file-upload-banner" class="custom-file-upload h-fit-content p-3 text-center">
                <mat-icon>{{!fileImg64DetailMobile ? 'image': '' }} </mat-icon>
                <span class="my-2" *ngIf="!wrongSize['s']">
                  {{benefitData['benefitsInstitutionId'] || fileImg64DetailMobile ? 'Cambiar ' : 'Agregar'}}
                  imagen mobile de 329px x 85px
                </span>
                <span class="my-2 text-danger" *ngIf="wrongSize['sM']">{{wrongSize['sM']}}</span>
              </label>
              <input id="file-upload-banner" type="file" accept="image/*" (change)="getBase64($event, 'sliderMobile')" />
            </div>
          </div>
          <h4 class="text-center">{{benefitData.id ? 'Editar ' : 'Ingresar '}}información de cupón en Modal</h4>
          <div class="row mx-0 my-3 p-0 w-100">
            <div class="col-12 col-xl-6 pl-xl-0 mt-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha de inicio de vigencia</mat-label>
                <input id="pickerStart" matInput [matDatepicker]="pickerStart" formControlName="startDate">
                <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-12 col-xl-6 pr-xl-0 mt-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha de fin de vigencia</mat-label>
                <input id="pickerEnd" matInput [matDatepicker]="pickerEnd" formControlName="endDate">
                <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                <mat-datepicker #pickerEnd></mat-datepicker>
              </mat-form-field>
              <mat-error *ngIf="convertDate(benefitForm.value.endDate) < convertDate()" style="margin-top: -1rem">
                La fecha seleccionada es menor a la fecha actual
              </mat-error>
            </div>
            <div class="col-12 mt-2 px-xl-0">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Url cupón</mat-label>
                <input formControlName="urlCoupon" matInput placeholder="Ingresar url" type="text">
                <mat-hint align="end">Ejemplo: www.jockeysalud.com.pe</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Información de vista modal Paso 2">
      <h4 class="text-center">{{benefitData.id ? 'Editar ' : 'Ingresar '}}información de cupón en Modal</h4>
      <div class="row mx-0 my-3 p-0 w-100">
        <div class="col-12 px-xl-0 mt-2">
          <label class="form-label text-dark">Subtítulo corto (opcional):</label>
          <quill-editor placeholder="Ejemplo: Consulta a domicilio" formControlName="detailHtml">
            <div quill-editor-toolbar class="w-100">
              <span class="ql-formats">
                <button class="ql-bold" [title]="'Bold'"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-align" [title]="'Justificación de texto'">
                  <option selected></option>
                  <option value="center"></option>
                  <option value="right"></option>
                  <option value="justify"></option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="bullet"></button>
              </span>
            </div>
          </quill-editor>
        </div>
        <div class="col-12 px-xl-0 mt-2">
          <label class="form-label text-dark">Descripción de validez (opcional):</label>
          <quill-editor placeholder="Ejemplo: Válido en Ca. Arica 151, Tacna, Perú" formControlName="detailHtml2">
            <div quill-editor-toolbar class="w-100">
              <span class="ql-formats">
                <button class="ql-bold" [title]="'Bold'"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-align" [title]="'Justificación de texto'">
                  <option selected></option>
                  <option value="center"></option>
                  <option value="right"></option>
                  <option value="justify"></option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="bullet"></button>
              </span>
            </div>
          </quill-editor>
        </div>
        <div class="col-12 px-xl-0 mt-2">
          <label class="form-label text-dark">Descripción amplia (con viñetas):</label>
          <quill-editor placeholder="• Válido presentando carnet de asegurado.   • Aplica solo ..."
            formControlName="detailHtml3">
            <div quill-editor-toolbar class="w-100">
              <span class="ql-formats">
                <button class="ql-bold" [title]="'Bold'"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-align" [title]="'Justificación de texto'">
                  <option selected></option>
                  <option value="center"></option>
                  <option value="right"></option>
                  <option value="justify"></option>
                </select>
              </span>
              <!--              <span class="ql-formats">-->
              <!--                <button class="ql-list" value="bullet"></button>-->
              <!--              </span>-->
            </div>
          </quill-editor>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <button type="submit" class="vs-btn-blue" [disabled]="benefitForm.invalid">
    {{benefitData && benefitData['benefitInstitutionId'] ? 'Editar cupón' : 'Guardar cupón'}}
  </button>
</form>
